import { Authentication } from "./ApiClientUtils";
import { AxiosRequestConfig } from "axios";
import { Brand } from "utility-types";
import produce from "immer";

export type BearerToken = Brand<string, "bearer-token">;

let token: any;

export const getBearerToken = (): BearerToken => {
  if (!token) {
    token = localStorage.getItem("user-token-ops");
  }
  return token as BearerToken;
};

export const withAuthentication =
  ({ authentication }: Partial<Authentication>) =>
  async (config: AxiosRequestConfig) => {
    if (authentication) {
      const bearerToken = await getBearerToken();

      return produce(config, (draft) => {
        if (draft.headers === undefined) {
          draft.headers = {};
        }
        draft.headers.Authorization = `Bearer ${bearerToken}`;
      });
    }

    return config;
  };

export const AmplifyConfigs = {
  // The following configurations are not sensitive data. It is safe to commit to the repository.
  staging: {
    aws_project_region: "us-east-1",
    aws_cognito_identity_pool_id:
      "us-east-1:acc62066-f4af-4ddb-b88b-c45a3e8bf070", // Cognito Identity Pool ID
    aws_cognito_region: "us-east-1",
    aws_user_pools_id: "us-east-1_u05eiiTCL", // User Pool ID
    aws_user_pools_web_client_id: "2rg16bbl4q0pk6aqevqc4ofglf", // App Client ID (without secret)
    oauth: {
      domain: "deliverr2.auth.us-east-1.amazoncognito.com",
      scope: ["aws.cognito.signin.user.admin", "email", "openid", "profile"],
      redirectSignIn: `${window.location.origin}/`, // redirect to the main page
      redirectSignOut: `${window.location.origin}/`, // redirect to the main page
      responseType: "code",
    },
  },
  production: {
    aws_project_region: "us-east-1",
    aws_cognito_identity_pool_id:
      "us-east-1:b82543dd-5f3f-4fee-be9a-af4249522fe4", // Cognito Identity Pool ID
    aws_cognito_region: "us-east-1",
    aws_user_pools_id: "us-east-1_uITdM0qhd", // User Pool ID
    aws_user_pools_web_client_id: "lbct8ik578fq4j403lkvvumbt", // App Client ID for "ops-portal"
    oauth: {
      domain: "deliverr3.auth.us-east-1.amazoncognito.com",
      scope: ["aws.cognito.signin.user.admin", "email", "openid", "profile"],
      redirectSignIn: `${window.location.origin}/`, // redirect to the main page
      redirectSignOut: `${window.location.origin}/`, // redirect to the main page
      responseType: "code",
    },
  },
};

export function getAmplifyConfig(): unknown {
  // We are using the production configuration. This can be enhanced in future, if needed, to switch between
  // configurations based on the staging, production and dev environment.
  return AmplifyConfigs["production"];
}
